const GetStadistict = (thiss, type) => {
  let params;

  if (thiss.currentUser.PositionID == 16) {
    params = {
      CompanyID: thiss.currentCompany,
      DirecctionID: thiss.directionId,
      DepartmentID: null,
      ResponsableID: thiss.employeeId,
      Byme: thiss.creadoPorMi,
      CreateByID: thiss.creadoPorMi ? thiss.currentUser.EmployeeId : 0,
      PerpectiveID: thiss.PerpectiveId,
      TypeStrategic: thiss.Strategic,
      // rolPermi: thiss.confirmRoles(),
      StatusTask: thiss.statusSelect,
      allTask: type == 1 ? true : false,
      taskOnLate: type == 2 ? true : false,
      taskOnCurrentWeek: type == 3 ? true : false,
      taskOnNextWeek: type == 4 ? true : false,
      taskOnMonth: type == 5 ? true : false,
      taskOnNextMonth: type == 6 ? true : false,
      Year: thiss.year,
      FourMonthPeriod: thiss.fourMonthPeriodType
    };
  } else {
    params = {
      CompanyID: thiss.currentCompany,
      DirecctionID: null,
      DepartmentID: null,
      ResponsableID: thiss.confirmRoles()
        ? thiss.employeeId == 0
          ? thiss.currentUser.EmployeeId
          : thiss.employeeId
        : thiss.currentUser.EmployeeId,
      Byme: thiss.creadoPorMi,
      CreateByID: thiss.creadoPorMi ? thiss.currentUser.EmployeeId : 0,
      PerpectiveID: thiss.PerpectiveId,
      TypeStrategic: thiss.Strategic,
      // rolPermi: thiss.confirmRoles(),
      StatusTask: thiss.statusSelect,
      allTask: type == 1 ? true : false,
      taskOnLate: type == 2 ? true : false,
      taskOnCurrentWeek: type == 3 ? true : false,
      taskOnNextWeek: type == 4 ? true : false,
      taskOnMonth: type == 5 ? true : false,
      taskOnNextMonth: type == 6 ? true : false,
      Year: thiss.year,
      FourMonthPeriod: thiss.fourMonthPeriodType
    };
  }
  thiss.$http
    .get(`/api/CMI/Objetives/GetGanttStadistic`, {
      timeout: 10 * 60 * 1000,
      params: params
    })
    .then(({ data }) => {
      thiss.statistics = data;
    })
    .finally(() => {
      thiss.loadingStadistic = false;
    });
};

export default GetStadistict;
